import { AddCircle } from "@solar-icons/react/ssr";
import { Button, Grid, Paper, useTheme, useMediaQuery } from "@mui/material";
import AddonForm from "./AddonForm";
import { request } from "@/Api";
import { getReadOnly, store } from "./bidStore";
import { useEffect, useState } from "react";

export default function AddonsForm({ bid: paramBid, addonsData }) {
    const [addons, setAddons] = useState(addonsData || []);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const activeBid = paramBid || store.bid;
    const bidId = activeBid.id;
    const readOnly = getReadOnly();

    const handleAddonBlur = (addon) => (field, val) => {
        if (!addon.id) {
            return;
        }
        const updatedAddon = { ...addon, [field]: val };
        request.put(`/bids/${bidId}/addon/${addon.id}`, updatedAddon);
    };

    const handleAddonDelete = (addon) => () => {
        request.delete(`/bids/${bidId}/addon/${addon.id}`);
    };

    const handleAddonAdd = () => {
        request.post(`/bids/${bidId}/addon`, {
            name: "New Addon",
            type: "amount",
            amount: 0,
            bid_id: bidId,
        });
    };

    useEffect(() => {
        setAddons([...addonsData]);
    }, [addonsData]);

    if (!addonsData) {
        return;
    }

    return (
        <Paper
            style={{
                boxShadow: "none",
                padding: isMobile ? "6px 12px 12px 12px" : "6px 30px 30px 30px",
                marginTop: isMobile ? 20 : 60,
            }}
        >
            <h4>Global add-ons</h4>
            {addons.map((addon) => (
                <AddonForm
                    key={addon.id}
                    bid={paramBid}
                    onAddonBlur={handleAddonBlur(addon)}
                    onAddonDelete={handleAddonDelete(addon)}
                    addonData={{ ...addon }}
                />
            ))}

            <Grid container alignItems={"center"}>
                <Grid item>
                    <Button
                        onClick={handleAddonAdd}
                        disabled={readOnly}
                        startIcon={
                            <AddCircle
                                color={readOnly ? "secondary" : "success"}
                                fontSize="tiny"
                            />
                        }
                    >
                        Add
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}
